// Use browser-global PapaParse loaded from public/index.html to avoid Webpack parsing papaparse package files.
const Papa = typeof window !== 'undefined' ? window.Papa : null;

if (!Papa) {
  throw new Error('PapaParse is not loaded. Ensure papaparse script is included in public/index.html.');
}

export default Papa;
